// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { SearchReconciliationiDocumentResultsDTO } from '../models';
/**
 * ReconciliationDocumentsApi - axios parameter creator
 * @export
 */
export const ReconciliationDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Search for Reconciliation Documents
         * @param {string} from Search to search from
         * @param {string} to Search to search to
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchReconciliationDocuments(from: string, to: string, page: number, size: number, options: any = {}): RequestArgs {
            // verify required parameter 'from' is not null or undefined
            if (from === null || from === undefined) {
                throw new RequiredError('from','Required parameter from was null or undefined when calling searchReconciliationDocuments.');
            }
            // verify required parameter 'to' is not null or undefined
            if (to === null || to === undefined) {
                throw new RequiredError('to','Required parameter to was null or undefined when calling searchReconciliationDocuments.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling searchReconciliationDocuments.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling searchReconciliationDocuments.');
            }
            const localVarPath = `/v2/reconciliations/documents/search`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReconciliationDocumentsApi - functional programming interface
 * @export
 */
export const ReconciliationDocumentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Search for Reconciliation Documents
         * @param {string} from Search to search from
         * @param {string} to Search to search to
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchReconciliationDocuments(from: string, to: string, page: number, size: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchReconciliationiDocumentResultsDTO>> {
            const localVarAxiosArgs = ReconciliationDocumentsApiAxiosParamCreator(configuration).searchReconciliationDocuments(from, to, page, size, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ReconciliationDocumentsApi - factory interface
 * @export
 */
export const ReconciliationDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Search for Reconciliation Documents
         * @param {string} from Search to search from
         * @param {string} to Search to search to
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchReconciliationDocuments(from: string, to: string, page: number, size: number, options?: any) {
            return ReconciliationDocumentsApiFp(configuration).searchReconciliationDocuments(from, to, page, size, options)(axios, basePath);
        },
    };
};

/**
 * ReconciliationDocumentsApi - interface
 * @export
 * @interface ReconciliationDocumentsApi
 */
export interface ReconciliationDocumentsApiInterface {
    /**
     * Search for Reconciliation Documents
     * @param {string} from Search to search from
     * @param {string} to Search to search to
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconciliationDocumentsApiInterface
     */
    searchReconciliationDocuments(from: string, to: string, page: number, size: number, options?: any): AxiosPromise<Array<SearchReconciliationiDocumentResultsDTO>>;

}

/**
 * ReconciliationDocumentsApi - object-oriented interface
 * @export
 * @class ReconciliationDocumentsApi
 * @extends {BaseAPI}
 */
export class ReconciliationDocumentsApi extends BaseAPI implements ReconciliationDocumentsApiInterface {
    /**
     * Search for Reconciliation Documents
     * @param {string} from Search to search from
     * @param {string} to Search to search to
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconciliationDocumentsApi
     */
    public searchReconciliationDocuments(from: string, to: string, page: number, size: number, options?: any) {
        return ReconciliationDocumentsApiFp(this.configuration).searchReconciliationDocuments(from, to, page, size, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ReconciliationDocumentsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Search for Reconciliation Documents
 * @param {string} from Search to search from
 * @param {string} to Search to search to
 * @param {number} page Page to start on (defaults to 1)
 * @param {number} size Size of result set to return (defaults to 15)
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function searchReconciliationDocuments(
    from: string,
    to: string,
    page: number,
    size: number,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<SearchReconciliationiDocumentResultsDTO>> {
    const localVarAxiosArgs = ReconciliationDocumentsApiAxiosParamCreator(configuration).searchReconciliationDocuments(from, to, page, size, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

